import React from "react";

import PaymentItems from "./PaymentItems";

import { BASIC_METHODS, PSD2_METHODS, WALLET_METHODS } from "../../Constants";
import { llog } from "../../utils/LogUtils";

const PaymentOption = (props) => {
  const { selectedMethod, setSelectedMethod, setSelectedLogo, activeMethods } = props;

  const handleSelect = (event, name, logo) => {
    event.preventDefault();
    setSelectedMethod(name);
    setSelectedLogo(logo);
    llog("Selected Method: " + name);
  };

  // TODO: Move to constants OR get from API
  const standardEnabled = true;
  const paybylinkEnabled = true;
  const walletsEnabled = false;

  const activePSD2Methods = PSD2_METHODS.map((method) => {
    method.active = activeMethods.includes(method.name);
    return method;
  });

  return (
    <>
      {standardEnabled && (
        <div className='d-flex flex-wrap justify-content-left'>
          <PaymentItems items={BASIC_METHODS} handleSelect={handleSelect} selectedMethod={selectedMethod} />
        </div>
      )}
      {paybylinkEnabled && (
        <>
          <div className='divider my-3' />
          <div className='d-flex flex-wrap justify-content-left'>
            <PaymentItems items={activePSD2Methods} handleSelect={handleSelect} selectedMethod={selectedMethod} />
          </div>
        </>
      )}
      {walletsEnabled && (
        <>
          <div className='divider my-3' />
          <div className='d-flex flex-wrap justify-content-left'>
            <PaymentItems items={WALLET_METHODS} handleSelect={handleSelect} selectedMethod={selectedMethod} />
          </div>
        </>
      )}
    </>
  );
};

export default PaymentOption;
